import React from "react";
import { Route, RouteProps, useHistory } from "react-router-dom";
import { UserContainer } from "../containers/User";
import { ErrorContainer } from "../containers/Error";
import { AppContainer } from "../containers/App";

/**
 * 認証制御用 Route モジュール
 * @param props RouteProps
 */
const AuthGuardRoute = (props: RouteProps) => {
  const appContainer = AppContainer.useContainer();
  const errorContainer = ErrorContainer.useContainer();
  const userContainer = UserContainer.useContainer();
  const user = userContainer.user;
  const history = useHistory();

  if (user.token || user.isAuthInvalid) {
    // 認証実施済みであれば、本来のRouteを返却
    return <Route {...props} />;
  } else {
    // 認証未実施であれば、認証を実施
    if (user.id) {
      // userIdを保持している場合、ログインを呼び出す
      if (!appContainer.context.loading) {
        appContainer.setLoading(true);
        userContainer
          .login()
          .then(() => {
            appContainer.setLoading(false);
          })
          .catch((error) => {
            errorContainer.setDefaultError(user.id || "", error);
          });
      }
    } else {
      // userIdを保持していない場合、ログイン画面に遷移
      history.push("/login");
    }
    return null;
  }
};

export default AuthGuardRoute;
